"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.webSDK = void 0;

var _httpRequest = _interopRequireDefault(require("../httpRequest"));

var _env = require("../env");

var _semver = require("../semver");

var _common = require("../common");

require("url-search-params-polyfill");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 0 测试；1线上
var testMode = 0;
/**
 * 微信 JS SDK 授权
 * @returns {Promise<any>}
 */

function initWeChatConfig() {
  return new Promise(function (resolve, reject) {
    getSignature().then(function (data) {
      if (!data) {
        reject({
          code: 4,
          msg: '签名获取失败'
        });
        return;
      } // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#11


      var jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'launchApplication', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'hideMenuItems', 'showMenuItems', 'getNetworkType', 'openLocation', 'getLocation', 'scanQRCode', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getLocalImgData'];
      var debugUrl = new URLSearchParams(location.search);
      var debugMode = !!debugUrl.get('wxdebug');
      var configParam = {
        debug: debugMode,
        // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId,
        // 公众号的唯一标识
        timestamp: data.timestamp,
        // 生成签名的时间戳
        nonceStr: data.nonceStr,
        // 生成签名的随机串
        signature: data.signature,
        // 签名
        jsApiList: jsApiList,
        // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        beta: true // 如果需要调用 launchApplication 接口, 需要设置此参数

      };
      wx.ready(function () {
        _common.Log.log('wx ready');

        resolve({
          code: 0,
          msg: 'ok',
          wx: wx
        });
      });
      wx.error(function (err) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        reject({
          code: 5,
          msg: err
        });
      });
      wx.config(configParam);
    });
  });
}

function getCurUrl() {
  return location.href.split('#')[0];
}

function getPureUrl(url) {
  var u = new URL(url);
  var searchParams = new URLSearchParams(u.search);
  var rmKeys = ['from', 'response_type', 'scope', 'state', 'pass_through', 'code', 'token', 'openid'];
  var i = -1;

  while (++i < rmKeys.length) {
    searchParams["delete"](rmKeys[i]);
  }

  var pureUrl = "".concat(u.origin).concat(u.pathname, "?").concat(searchParams.toString());
  return pureUrl;
}
/**
 * 获取微信 SDK 授权签名
 * @returns {Promise}
 */


function getSignature() {
  // 请求后台接口获取签名
  var signUrl = '/app-api-common-server/white/wechat/evokeapp/config.json';
  var params = {
    url: getCurUrl(),
    type: testMode // 0 测试；1线上

  };
  return _httpRequest["default"].get(signUrl, params).then(function (res) {
    if (res.code === 10000) {
      return res.data;
    }
  });
}

function handleParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var title = params.title,
      desc = params.desc,
      link = params.link,
      imgUrl = params.imgUrl;

  var _link = link || location.href;

  var tempShareInfo = {
    title: title || '少年得到',
    // 分享标题
    desc: desc || '天下名师服务一个孩子',
    // 分享描述
    link: getPureUrl(_link),
    // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: imgUrl || 'https://coolcdn.igetcool.com/t/2019/10/280c61e15fa20f4be9ece4cd70a43cc6de.png' // 分享图标

  };
  return tempShareInfo;
}
/**
 * 设置微信分享信息
 * @param {Object} shareInfo
 */


function handleWeChatShare(shareInfo) {
  var title = shareInfo.title,
      desc = shareInfo.desc,
      imgUrl = shareInfo.imgUrl,
      link = shareInfo.link;
  var params = {
    title: title,
    desc: desc,
    imgUrl: imgUrl,
    link: link,
    success: function success() {
      _common.Log.log('handleWxShare success');
    },
    cancel: function cancel() {
      _common.Log.log('handleWxShare cancel');
    },
    error: function error(err) {
      _common.Log.log('handleWxShare error', err);
    }
  };
  wx && wx.ready(function () {
    // 需在用户可能点击分享按钮前就先调用
    _common.Log.log('handleWxShare', params);

    wx.updateAppMessageShareData(params);
    wx.updateTimelineShareData(params);
    wx.onMenuShareWeibo(params);
  });
}
/**
 * 设置 QQ 分享信息
 * @param {Object} shareInfo
 */


function handleQQShare(shareInfo) {
  var paramQQ = {
    title: shareInfo.title,
    // 分享标题
    summary: shareInfo.desc,
    // 分享内容
    pic: shareInfo.imgUrl,
    // 分享图片
    url: shareInfo.link,
    // 分享链接
    // 微信权限验证配置信息，若不在微信传播，可忽略
    WXconfig: {// swapTitleInWX: false, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
      // appId: data.appId, // 公众号的唯一标识
      // timestamp: data.timestamp, // 生成签名的时间戳
      // nonceStr: data.nonceStr, // 生成签名的随机串
      // signature: data.signature // 签名
    }
  };
  setShareInfo && setShareInfo(paramQQ);
}

function wxCallApp(param) {
  var openurl = param.openUrl;
  window.WeixinJSBridge.invoke('launchApplication', {
    'appID': 'wx9516c6869545c65c',
    'parameter': openurl,
    // 自定义 scheme URL 中的 path 部分
    'extInfo': openurl // 格式可以自定义，第三方 APP 自主处理，可以是 path 或 json 等

  }, function (res) {
    /*
     * 调用成功返回“launchApplication:ok”，
     * 包括成功打开了 app 或者用户在弹窗上点击取消拉起 app
     *
     * 调用失败返回“launchApplication:fail”，jsapi 本身调用失败，
     * 或安卓上该应用未安装，或 iOS 上用户在弹窗上点击拉起但该应用未安装
     *
     */
    if (res.err_msg !== 'launchApplication:ok') {
      _common.Log.warn('launchApplication err: ', res);

      if (param.invokeFailShowGuide) {
        showGuide();
      } else {
        location.href = param.downloadUrl;
      }
    }
  });
}

var showGuide = function showGuide() {
  var domBody = document.body;
  var guideHtml = "\n    <div id='wxGuide' style='\n      position: fixed;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      z-index: 9999;\n      background: rgba(0,0,0, 0.5);\n      text-align: center;'>\n      <img src=\"https://coolcdn.igetcool.com/p/2021/12/ea7596e4e7cb76b2a5b4efb96be04c71.png?_675x762.png\" \n      style='\n        position: absolute;\n        top: 20px;\n        left: 10%;\n        width: 80%;' alt=\"\">\n    </div>";
  var newEl = document.createElement('div');
  newEl.innerHTML = guideHtml;
  domBody.appendChild(newEl); // 点击取消引导

  newEl.addEventListener('click', function () {
    domBody.removeChild(newEl);
  });
};

var APP_DOWNLOAD_URL = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.dedao.juvenile';
/**
 * h5 唤起 app
 * @param {string} url 唤起的页面
 * @param {Object=} options
 * @param {number=} options.time 唤起后多少毫秒转到到下载页
 * @param {boolean=} options.preventDownload 默认不阻止跳转下载
 */

function h5CallApp(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var time = options.time,
      preventDownload = options.preventDownload,
      downloadUrl = options.downloadUrl; // 获取时间

  var starTime = +new Date(); // 先尝试跳转

  if (_env.env.isAndroid) {
    // 安卓终端使用iframe
    var iFrame = document.createElement('iframe');
    iFrame.src = url;
    iFrame.style.display = 'none';
    document.body.appendChild(iFrame); // 发起请求后这个 iFrame 就没用了，所以把它从 dom 上移除掉

    iFrame.parentNode.removeChild(iFrame);
    iFrame = null;
  } else {
    // FIXME: 有百度浏览器会拦截自定义 scheme，可能需要提示一下，但是鉴于用户很少，不做处理先
    location.href = url;
  } // 再次获取时间


  var endTime = +new Date(); // 验证时间差，如果是阻拦代码执行的浏览器，时间会长一点，但是有的浏览器弹出一个框，不会阻止代码执行，时间会很短

  time = typeof time !== 'undefined' ? time : endTime - starTime < 100 ? 3000 : 1000;

  if (!preventDownload) {
    // 跳转下载页
    window.setTimeout(function () {
      if (!document.hidden) {
        window.location.href = downloadUrl || APP_DOWNLOAD_URL;
      }
    }, time);
  }
}

function _openApp(openUrl) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (_env.env.isApp) {
    return;
  }

  openUrl = openUrl || _common.appRouter.home;
  var param = {
    downloadUrl: options.downloadUrl || APP_DOWNLOAD_URL,
    // 微信中是否展示浏览器下载引导图，默认为false
    invokeFailShowGuide: options.invokeFailShowGuide,
    openUrl: openUrl
  };

  if (_env.env.isWeChat && (0, _semver.compareVersion)(_env.env.appVer, '6.5.16') > 0) {
    if (window.WeixinJSBridge) {
      wxCallApp(param);
    } else {
      document.addEventListener('WeixinJSBridgeReady', function () {
        wxCallApp(param); // 此时立即调用权限可能还未准备好，所以 wxCallApp 里需要延迟调用
      });
    }
  } else {
    if (_env.env.isQQ) {
      h5CallApp(openUrl, _objectSpread(_objectSpread({}, options), {
        time: 0
      }));
    } else {
      h5CallApp(openUrl, options);
    }
  }
}
/**
 * Web SDK 模块
 * 主要功能：
 * 1. 微信\QQ JS SDK 授权，为页面提供：分享信息设置、从微信唤起 App、设置微信菜单
 *
 * @module webSDK
 * @example:
 *
 * const shareInfo = {
 *   title: '',
 *   link: '',
 *   desc: '',
 *   imgUrl: ''
 * };
 * // 初始化 SDK，并设置分享信息。
 * webSDK.init().then(() => {
 *   webSDK.setShare(shareInfo);
 * });
 *
 * // 或者，该方法会自动注册 SDK
 * webSDK.setShare(shareInfo);
 *
 * 2. H5 中唤起 App，如果 App 未安装或者唤起失败，跳转至应用宝链接。
 * // 微信内唤起 App。
 * webSDK.init().then(() => {
 *    webSDK.openApp({
 *      url: ''
 *    });
 * });
 *
 * // 或者，该调用打开会会有延迟，因为注册 SDK 会异步。
 * webSDK.openApp({
 *   url: ''
 * })
 *
 *
 */


var webSDK = {
  _fuze: new _common.Fuze(),
  // 0: 未开始；1：进行中；2：完成
  _sdkLoaded: 0,
  _inited: 0,
  _readyUrl: '',

  /**
   * 设置基本 SDK 初始化状态
   * @param {Object=} options
   * @options {number=} options.mode 测试模式开关。0：测试，1：正式。默认正式环境
   * @returns {webSDK}
   * 这里有个问题：后端文档写的的也是 0：测试，1：正式。但是后端测试环境的代码里实际逻辑是 0 为正式环境，1 为测试。正式环境 0 为正式，1 也为正式
   * 而唤起 App 只能使用线上环境的 AppId 才可以。因此本次测试的时候，也只能使用 0
   */
  config: function config() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    options = _objectSpread(_objectSpread({}, {
      mode: 0
    }), options);

    _common.Log.log('setConfig ', options);

    testMode = options.mode;
    return this;
  },

  /**
   * 加载依赖的 SDK
   * 1. 建议再其他脚本执行前加载
   * 2. 或者直接使用外联 script 标签加载
   * @param {Object=} options
   * @options {boolean=} options.wechat 默认加载微信 sdk
   * @options {boolean=} options.qq 默认加载qq sdk
   */
  _load: function _load() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (resolve, reject) {
      if (_this._sdkLoaded === 1) {
        return;
      }

      _this._sdkLoaded = 1;
      options = _objectSpread(_objectSpread({}, {
        wechat: true,
        qq: true
      }), options); // 判断微信 sdk
      // Doc: https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html

      var protocol = location.protocol;

      if (!/^(http|https):$/.test(protocol)) {
        // 如果不是 http 类型，强制 https，防止 file 协议的情况
        protocol = 'https:';
      }

      if (options.wechat && _env.env.isWeChat) {
        if (typeof wx === 'undefined' || typeof wx.config !== 'function') {
          (0, _common.loadScript)("".concat(protocol, "//res.wx.qq.com/open/js/jweixin-1.4.0.js")).then(function () {
            _this._sdkLoaded = 2;
            resolve();

            _common.Log.log('WX SDK loaded!');
          })["catch"](function (err) {
            _this._sdkLoaded = 0;
            reject();

            _common.Log.warn('WX SDK load fail!', err);
          });
        } else {
          _this._sdkLoaded = 2;
          resolve();

          _common.Log.log('WX SDK has loaded!');
        }
      } else if (options.qq && _env.env.isQQ) {
        if (typeof setShareInfo !== 'function') {
          (0, _common.loadScript)("".concat(protocol, "//qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js")).then(function () {
            _this._sdkLoaded = 2;
            resolve();

            _common.Log.log('QQ SDK loaded!');
          })["catch"](function (err) {
            _this._sdkLoaded = 0;
            reject();

            _common.Log.warn('QQ SDK load fail!', err);
          });
        } else {
          _this._sdkLoaded = 2;
          resolve();

          _common.Log.log('QQ SDK has loaded!');
        }
      } else {
        _this._sdkLoaded = 2;
        resolve();
      }
    });
  },

  /**
   * 初始化 webSDK
   * 由于授权是异步进行的，因此建议在页面组件加载完毕后立即执行，以保证在 webSDK 使用时无需等待。
   * 如果不调用init，内部也会在 webSDK 执行具体方式时在进行异步调用。但是带来的问题是方法调用有等待时间。
   * @param {Object=} options 配置项同 init 函数
   * @options {boolean=} options.force 是否强制重新进行 SDK 授权，默认false。即当前 url 授权后，再次调用不再进行授权。
   */
  init: function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // 初始化中
    if (this._inited === 1) {
      return;
    } // 已初始化，但授权路径变更，或者开启强制更新


    if (this._inited === 2 && this._readyUrl === getCurUrl() && !options.force) {
      return;
    }

    this._inited = 1;
    this.config(options);

    this._load(options).then(function () {
      if (_env.env.isWeChat && !_env.env.isMiniProgram) {
        initWeChatConfig().then(function () {
          _this2._inited = 2;
          _this2._readyUrl = getCurUrl();

          _this2._fuze.fire();
        })["catch"](function (err) {
          _this2._inited = 0;
        });
      } else {
        _this2._inited = 2;
        _this2._readyUrl = getCurUrl();

        _this2._fuze.fire();
      }
    })["catch"](function (err) {
      _this2._inited = 0;
    });
  },

  /**
   * 设置分享信息
   * @param {Object} shareParams
   * @options {string} shareParams.title 分享标题
   * @options {string} shareParams.link 分享链接
   * @options {string} shareParams.desc 分享描述
   * @options {string} shareParams.imgUrl 分享图片
   * @param {Object} options
   * @options {number} options.mode 测试签名模式，默认线上环境
   *
   * @example:
   *
   * webSDK.setShare({
   *   title: '',
   *   link: '',
   * }, {
   *   mode: 1 // 测试 0， 正式 1
   * })
   */
  setShare: function setShare(shareParams, options) {
    this.init(options);

    this._fuze.add(function () {
      _common.Log.log('setShare ', shareParams);

      var shareInfo = handleParams(shareParams);

      if (_env.env.isWeChat) {
        handleWeChatShare(shareInfo);
      } else if (_env.env.isQQ) {
        handleQQShare(shareInfo);
      } else {// Do nothing
      }
    });
  },

  /**
   * 设置微信菜单显示隐藏状态
   * docs: https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#43
   * @param {Object} options
   * @options {boolean} options.hideAllNonBaseMenuItem 隐藏所有非基础按钮接口，默认 false
   * @options {boolean} options.showAllNonBaseMenuItem 显示所有功能按钮接口，默认 false
   * @options {Array<string>} options.hideMenuItems 批量隐藏功能按钮接口。要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮。
   * @options {Array<string>} options.showMenuItems 批量显示功能按钮接口。要显示的菜单项。
   *
   */
  setWeChatMenu: function setWeChatMenu() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.init(options);
    var hideAllNonBaseMenuItem = options.hideAllNonBaseMenuItem,
        showAllNonBaseMenuItem = options.showAllNonBaseMenuItem,
        hideMenuItems = options.hideMenuItems,
        showMenuItems = options.showMenuItems;

    this._fuze.add(function () {
      if (_env.env.isWeChat) {
        wx.ready(function () {
          _common.Log.log('setWeChatMenu', options);

          if (hideAllNonBaseMenuItem) {
            wx.hideAllNonBaseMenuItem();
          }

          if (showAllNonBaseMenuItem) {
            wx.showAllNonBaseMenuItem();
          }

          if (hideMenuItems && hideMenuItems.length > 0) {
            wx.hideMenuItems({
              menuList: hideMenuItems // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3

            });
          }

          if (showMenuItems && showMenuItems.length > 0) {
            wx.showMenuItems({
              menuList: showMenuItems // 要显示的菜单项，所有menu项见附录3

            });
          }
        });
      }
    });
  },

  /**
   * 唤起 App，包含微信中唤起
   * @param {string} url 跳转的 URL，支持 igetcool 协议
   * @param {Object=} options 配置项
   */
  openApp: function openApp(url, options) {
    this.init(options);

    this._fuze.add(function () {
      _common.Log.log('openApp ', url);

      _openApp(url, options);
    });
  },
  miniProgram: function miniProgram(MEHTOD, options) {
    if (!MEHTOD) {
      return;
    }

    this.init();

    this._fuze.add(function () {
      _common.Log.log('miniProgram ', MEHTOD);

      var handle = wx.miniProgram[MEHTOD];

      if (typeof handle === 'function') {
        handle(options);
      }
    });
  }
};
exports.webSDK = webSDK;